import moment from 'moment-mini'

import { Injectable } from '@angular/core'

import { EmailTask } from './email-task'

@Injectable()
export class EmailTaskSerializer {
  fromJson(json: any): EmailTask {
    const emailTask = {
      ...json
    }

    return emailTask
  }

  toJson(emailTask: EmailTask): any {
    return {
      ...emailTask
    }
  }
}
